<!-- =========================================================================================
    File Name: JDataTable = JqueryDataTable
    Description: Datatable
    ----------------------------------------------------------------------------------------
    Author: trongdd@eway.vn

    * Why we use JQuery in VueJS ?
    - This is a old source, i cannot force all to vuejs, to extend old code and customize it
========================================================================================== -->

<template>
    <vx-card :noShadow="noShadow" class="jquery-datatable-card" :class="{
        'jquery-datatable-card--no-spacing': noSpacing
    }">

        <slot name="datatable-header-top"></slot>
        <div class="datatable-header-per-page mb-2">
            {{ $t('components.jDataTable.perPageText') }}
            <v-simple-select @change="onPaginationPerPageChange" :options="paginationPerPage" />
        </div>
        <slot name="datatable-header"></slot>

        <table
            :id="dataTableId"
            class="dataTable jquery-datatable responsive w-100"
        >
            <thead @click.capture="onSorting">
                <tr>
                    <th v-for="(column, index) in columns"
                        :key="index"
                        :aria-field="column.data"
                        :aria-sorted="sortField[column.data] ? sortField[column.data] : 'none'">
                        {{column.name || $t(column.i18nName) || "Không rõ"}}


                        <vx-tooltip class="inline-block" style="transform: translateY(4px)" v-if="column.tooltip ? column.tooltip : false" :text="column.tooltip" position="top">
                            <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.708374 8.50001C0.708374 4.17918 4.17921 0.708344 8.50004 0.708344C12.8209 0.708344 16.2917 4.17918 16.2917 8.50001C16.2917 12.8208 12.8209 16.2917 8.50004 16.2917C4.17921 16.2917 0.708374 12.8208 0.708374 8.50001ZM2.12504 8.50001C2.12504 12.0417 4.95837 14.875 8.50004 14.875C12.0417 14.875 14.875 12.0417 14.875 8.50001C14.875 4.95834 12.0417 2.12501 8.50004 2.12501C4.95837 2.12501 2.12504 4.95834 2.12504 8.50001ZM9.20837 8.50001V11.3333C9.20837 11.7583 8.92504 12.0417 8.50004 12.0417C8.07504 12.0417 7.79171 11.7583 7.79171 11.3333V8.50001C7.79171 8.07501 8.07504 7.79168 8.50004 7.79168C8.92504 7.79168 9.20837 8.07501 9.20837 8.50001ZM9.20837 5.66668C9.20837 5.45418 9.13754 5.31251 8.99587 5.17084C8.85421 5.02918 8.57087 4.95834 8.35837 4.95834C8.31764 4.99908 8.30033 5.01639 8.27951 5.02374C8.26412 5.02918 8.24681 5.02918 8.21671 5.02918C8.18129 5.02918 8.16358 5.04688 8.14587 5.06459C8.12817 5.0823 8.11046 5.10001 8.07504 5.10001L8.00421 5.17084C7.86254 5.31251 7.79171 5.45418 7.79171 5.66668C7.79171 5.87918 7.86254 6.02084 8.00421 6.16251C8.00421 6.16251 8.00421 6.23334 8.07504 6.23334C8.11046 6.23334 8.12817 6.25105 8.14587 6.26876C8.16358 6.28647 8.18129 6.30418 8.21671 6.30418C8.25744 6.34491 8.27475 6.36222 8.29557 6.36957C8.31096 6.37501 8.32827 6.37501 8.35837 6.37501H8.50004C8.71254 6.37501 8.85421 6.30418 8.99587 6.16251C9.13754 6.02084 9.20837 5.87918 9.20837 5.66668Z" fill="#BABFC7"/>
                                <mask id="mask0_1268_45188" style="mask-type:alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="17" height="17">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0.708374 8.50001C0.708374 4.17918 4.17921 0.708344 8.50004 0.708344C12.8209 0.708344 16.2917 4.17918 16.2917 8.50001C16.2917 12.8208 12.8209 16.2917 8.50004 16.2917C4.17921 16.2917 0.708374 12.8208 0.708374 8.50001ZM2.12504 8.50001C2.12504 12.0417 4.95837 14.875 8.50004 14.875C12.0417 14.875 14.875 12.0417 14.875 8.50001C14.875 4.95834 12.0417 2.12501 8.50004 2.12501C4.95837 2.12501 2.12504 4.95834 2.12504 8.50001ZM9.20837 8.50001V11.3333C9.20837 11.7583 8.92504 12.0417 8.50004 12.0417C8.07504 12.0417 7.79171 11.7583 7.79171 11.3333V8.50001C7.79171 8.07501 8.07504 7.79168 8.50004 7.79168C8.92504 7.79168 9.20837 8.07501 9.20837 8.50001ZM9.20837 5.66668C9.20837 5.45418 9.13754 5.31251 8.99587 5.17084C8.85421 5.02918 8.57087 4.95834 8.35837 4.95834C8.31764 4.99908 8.30033 5.01639 8.27951 5.02374C8.26412 5.02918 8.24681 5.02918 8.21671 5.02918C8.18129 5.02918 8.16358 5.04688 8.14587 5.06459C8.12817 5.0823 8.11046 5.10001 8.07504 5.10001L8.00421 5.17084C7.86254 5.31251 7.79171 5.45418 7.79171 5.66668C7.79171 5.87918 7.86254 6.02084 8.00421 6.16251C8.00421 6.16251 8.00421 6.23334 8.07504 6.23334C8.11046 6.23334 8.12817 6.25105 8.14587 6.26876C8.16358 6.28647 8.18129 6.30418 8.21671 6.30418C8.25744 6.34491 8.27475 6.36222 8.29557 6.36957C8.31096 6.37501 8.32827 6.37501 8.35837 6.37501H8.50004C8.71254 6.37501 8.85421 6.30418 8.99587 6.16251C9.13754 6.02084 9.20837 5.87918 9.20837 5.66668Z" fill="white"/>
                                </mask>
                                <g mask="url(#mask0_1268_45188)">
                                <rect width="17" height="17" fill="#BABFC7"/>
                                </g>
                            </svg>
                        </vx-tooltip>
                    </th>
                </tr>
            </thead>
            <tbody></tbody>
            <tfoot>
                <tr></tr>
            </tfoot>
        </table>

        <div v-if="typeof showPagination !== 'boolean' ? true : showPagination" class="block text-center md:text-left md:flex flex-wrap mt-4 items-center">
            <div class="font-normal text-sm mb-4 mb:0" style="color: #4b4b4b;">
                {{computedInfo}}
            </div>
            <div class="ml-auto md:inline-flex items-center">
                <div class="jquery-data-table__goTo mb-4 md:mb-0">
                    <label for="">{{ $t("components.jDataTable.goToText") }}</label>
                    <input type="number" min="1" v-model="goTo" />
                </div>
                <!-- <vs-pagination @change="onPaginationChange" :total='computedTotalPages' v-model='currentPage'></vs-pagination> -->
                <pagination class="justify-center md:justify-start" :page-count="computedTotalPages" @change="onPaginationChange" v-model="currentPage" :page="currentPage" />
            </div>
        </div>
    </vx-card>
</template>

<script>
import VxCard from "../vx-card/VxCard.vue";
import VSimpleSelect from '../Select/VSimpleSelect.vue';
import "@/components/report/date-eu.js";
import _ from 'lodash';
import Pagination from '../Pagination/Pagination.vue';
import VxTooltip from '../Tooltip/VxTooltip.vue';
import { mapState } from "vuex";

export default {
    components: { VxCard, VSimpleSelect, Pagination, VxTooltip },
    name: "jquery-datatable",
    props: {
        // @remind $emit : onDrawCallback: Function,
        // @remind $emit : onFooterCallback: Function,
        // @remind $emit : onPaginateChange : Function
        // @remind $emit : onSortChange : Function
        // @remind $emit : onSelectedItem : Function
        // @remind $emit : onGetInstance : Function
        // @remind $emit : onSelectRow: Function

        type: {
            type: String,
            default: "clientside", // "clientside" | "serverside" -> to pagination on client or server api handle
        },

        sortField: {
            type: Object,
            default: () => ({  }),
        },

        dataTableId: {
            type: String,
            default: "j-data-table-v1"
        },
        columns: {
            type: Array,
            default: [],
        },
        config: {
            type: Object,
            default: () => ({}),
        },
        data: {
            type: Array,
            default: [],
        },

        page: {
            type: Number,
            default: () => null,
        },
        perPage: {
            type: Number,
            default: () => 10
        },
        totalPage: Number,
        totalData: Number,

        // Modify css
        noShadow: {
            type: Boolean,
            default: false,
        },
        noSpacing: {
            type: Boolean,
            default: false,
        },

        /** @type {{html: string}} dataTableEmpty */
        dataTableEmpty: {
            html: {
                type: String,
                default: "",
            },
            default: () => ({
                html: "",
            }),
        },

        showPagination: {
            type: Boolean,
            default: () => true,
        },
    },

    data() {
        const shouldBePaginateOnClient = this.type === "clientside" ? true : false;
        return {
            dataTableInstance: null,

            config_: {
                language: "vi",
                destroy: true,
                processing: true,
                bPaginate: shouldBePaginateOnClient,
                bLengthChange: false,
                bFilter: true,
                bInfo: true,
                searching: false,
                autoWidth: true,
                responsive: true,
                scrollX: true,
                ...this.config,
            },

            goTo: 1,
            currentPage: this.$props.page || 1,
            // perPage: 10, // default
            currentPerPage: this.$props.perPage,
            paginationPerPage: [
                {label: 10, value: 10},
                {label: 25, value: 25},
                {label: 50, value: 50},
                {label: 100, value: 100},
            ],
            paginateTotalPage: this.totalPage || (Math.ceil((this.data || []).length / 10)), // default
        };
    },

    methods: {
        // $emit event
        onEmitPaginateChange() {
            this.$emit("onPaginateChange", {
                page: this.$data.currentPage,
                perPage: this.$data.currentPerPage,
                totalPage: this.computedTotalPages,
            });
        },

        onSorting() {
            this.$emit("onSorting");
        },

        onEmitSelectItem(item) {
            this.$emit("onSelectItem", { data: item });
        },
        // end: $emit event

        onChangeTextInfoDatatable() {
            const text = {
                Showing: this.$t("components.jDataTable.showing"),
                to: this.$t("components.jDataTable.to"),
                of: this.$t("components.jDataTable.of"),
                entries: this.$t("components.jDataTable.entries"),
            }
            const element = document.querySelector(`#${this.dataTableId}_info`);

            element.classList.add("text-darkblue");
            element.innerHTML = element.textContent
                .replace("Showing", text.Showing)
                .replace("to", text.to)
                .replace("of", text.of)
                .replace("entries", text.entries)
        },

        onEmptyData() {
            const emptyEl = document.querySelector(`#${this.dataTableId} .dataTables_empty`);

            // Should display or not html message
            if(this.dataTableEmpty.html && emptyEl) {
                emptyEl.innerHTML = this.dataTableEmpty.html;
            }

            // Should or not display info with pagination
            if(emptyEl && !this.showPagination) {
                emptyEl.classList.add("dataTables_empty--hidden")
            }
        },

        onHiddenPaginateDataTable() {
            const paginate = document.querySelector(`#${this.dataTableId}_paginate`);

            if(paginate) {
                paginate.classList.add("hidden");
            }
        },

        onListenSelectedItem() {
            // @note @deperated Events Of datatable not working
            // this.dataTableInstance.on("select", function ( e, dt, type, indexes ) {
            //     console.log("selected")
            // } );

            const _this = this;
            $(`#${this.dataTableId}_wrapper tbody`).off().on('click', 'tr', (e) => {
                let item = _this.dataTableInstance.row(e.currentTarget).data();
                _this.onEmitSelectItem(item);
            });
        },

        onPaginationChange: _.debounce(function({ currentPage }) {
            if(this.type === "clientside") {
                this.dataTableInstance.page( Number(currentPage) - 1 ).draw( 'page' );
                this.onEmitPaginateChange();
            }

            if(this.type === "serverside" && this.page !== currentPage) {
                this.onEmitPaginateChange();
            }
        }, 200),

        //When perPage selection change
        onPaginationPerPageChange: _.throttle(function(perPage) {
            if(this.type === "clientside") {
                this.dataTableInstance.page.len( perPage ).draw();
            }

            this.currentPage = 1;
            this.currentPerPage= perPage;

            this.onEmitPaginateChange();
        }, 200),

        onSortingDataTableServerSide() {
            const _this = this;
            $(`#${this.dataTableId}_wrapper thead th`).off().on("click",function() {
                const element = this;
                const field = $(element).attr("aria-field");
                const sorted = $(element).attr("aria-sorted");

                // only column not disabled to sorting
                if(!$(element).hasClass("sorting_disabled")) {
                    // Selected
                    if(sorted !== "none") {
                        if(sorted === "asc") {
                            $(element).attr("aria-sorted", "desc");

                            _this.$emit("onSortChange", {
                                type: "desc",
                                field: field
                            });
                        }

                        if(sorted === "desc") {
                            $(element).attr("aria-sorted", "asc");

                            _this.$emit("onSortChange", {
                                type: "asc",
                                field: field
                            });
                        }
                    }

                    // Non Selected, default is ascending
                    else {
                        _this.$emit("onSortChange", {
                            type: "asc",
                            field: field
                        });
                    }
                }
            });
        },

        onDrawDataTable() {
            if(this.dataTableInstance) {
                // Wait DOM updated cycle then execute re-draw instance jDataTable (resize column of previous instance changed)
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.dataTableInstance.draw();
                    }, 400);
                });
            };
        },

        onMounted() {
            // fin.masoffer.com version use Jquery to create DataTable
            // We need to extend old code to create an component for reusable
            // After: Force to datatable vue

            const _this = this;

            this.dataTableInstance = $(`#${this.dataTableId}`).DataTable({
                ...this.config_,
                data: this.data || [],
                columns: this.columns || [],
                dom: '<"top">rt<"bottom"iflp><"clear">',
                footerCallback: function (row, data, start, end) {
                    const self = this;
                    _this.$emit("onFooterCallback", {
                        row,
                        data,
                        start,
                        end,
                        self,
                    });
                },
                drawCallback: () => {
                    const datatableInstance = $(`#${this.dataTableId}`).DataTable();

                    this.$emit("onDrawCallback", datatableInstance);

                    this.$emit("onGetInstance", datatableInstance)

                    this.onChangeTextInfoDatatable();

                    this.onHiddenPaginateDataTable();

                    this.onEmptyData();

                    this.onListenSelectedItem();

                    this.type === "serverside" && this.onSortingDataTableServerSide();

                    const _instanceThis = this;
                    $(`#${this.dataTableId} tbody `).on("click", "tr", function() {
                        const dataRow = _instanceThis.dataTableInstance.row($(this)).data();

                        _instanceThis.$emit("onSelectRow", dataRow);
                    });
                },
            });
        },
    },

    computed: {
        computedTotalPages() {
            if(this.type === "clientside") {
                return this.totalPage || (Math.ceil((this.data || []).length / this.perPage)) || 0;
            }
            else {
                return this.totalPage || (Math.ceil((this.data || []).length / 10)) || 0;
            }
        },

        computedSortField() {
            return this.sortField;
        },

        computedInfo() {
            const text = {
                Showing: this.$t("components.jDataTable.showing"),
                to: this.$t("components.jDataTable.to"),
                of: this.$t("components.jDataTable.of"),
                entries: this.$t("components.jDataTable.entries"),

            }

            // Calculate perPage, currentPage and totalPage on table
            const _currentPage = this.currentPage || 1;
            const startPerPage = (((_currentPage - 1) * this.perPage) + 1);
            const endPerPage = (_currentPage * this.perPage) < (this.totalData || (this.data || []).length) ?
                    _currentPage * this.perPage :
                    (this.totalData || (this.data || []).length);
            const totalPage = (this.totalData) || ((this.data || []).length);

            // Display string
            return `${text.Showing}  ${startPerPage} ${text.to} ${endPerPage} ${text.of} ${totalPage} ${text.entries}`
        },

        ...mapState({
            verticalNavMenuWidth : state => state.verticalNavMenuWidth

        })
    },

    watch: {
        data() {
            this.dataTableInstance.clear().destroy();
            this.onMounted();
            if(this.type === "clientside") {
                this.dataTableInstance.page.len( this.perPage ).draw();
            }
        },

        page() {
            this.currentPage = this.$props.page;
        },

        goTo() {
            const nextToPage = Number(this.goTo);

            // Limit next page minimum is 1 page, not less 1
            // if(nextToPage <= 0) {
            //     this.goTo = 1;
            // }

            if(nextToPage > this.computedTotalPages) {
                this.goTo = this.computedTotalPages;
                return;
            }

            this.currentPage = nextToPage;

            // Re-call paginate when update new current-page
            // for user want to moving
            // Client-side
            if(this.type === "clientside") this.dataTableInstance.page( Number(this.currentPage || 1) - 1 ).draw( 'page' );
            // Server-side
            else if(this.type === "serverside") this.onEmitPaginateChange();
        },
        verticalNavMenuWidth(val) {
            const headerInner = document.querySelector('.dataTables_scrollHeadInner');
			const footerInner = document.querySelector('.dataTables_scrollFootInner');
            if (val ==='reduced') {
				headerInner.classList.add('width100');
				footerInner.classList.add('width100');
            } else {
                if (headerInner.classList.contains('width100')) {
					headerInner.classList.remove('width100');
                }
				if (footerInner.classList.contains('width100')) {
					footerInner.classList.remove('width100');
				}
            }
        }
    },

    mounted() {
        this.onMounted();

    },

    beforeDestroy() {
    },

};
</script>

<style scoped lang="scss">

$borderColor: #B9B9C3;

.width100 {
    width: 100% !important;
}
.jquery-datatable-card {

    .vx-card__body {
        // padding: 0 !important;
    }

    .jquery-data-table__goTo {
        margin-right: 16px;
        input {
            max-width: 45px;
            border: 1px solid #D8D6DE;
            border-radius: 5px;
            padding: 5px 8px;
            background-color: transparent;
            padding: 4px;
        }
    }

    &.jquery-datatable-card--no-spacing {
        .vx-card__body {
            padding: 0;
        }
    }
}

.dataTables_wrapper {
    .dataTables_scrollHeadInner {
        border-bottom: 1px solid transparent;
        @media only screen and (min-width:1401px) {
            width: 100% !important;
        }
        .jquery-datatable {
            width: 100% !important;
            thead {
                border-bottom: 1px solid $borderColor;
                tr {
                    th {
                        color: #4b4b4b;
                        border-bottom: 1px solid $borderColor;
                        &[aria-sorted="desc"] {
                            background-image: url(/images/vendor/datatables.net-dt/sort_desc.png) !important;
                        }

                        &[aria-sorted="asc"] {
                            background-image: url(/images/vendor/datatables.net-dt/sort_asc.png) !important;
                        }

                        &::before,
                        &::after {
                            font-size: 1.4rem;
                        }
                    }
                }
            }
        }
    }

    .dataTables_scrollBody {
        width: 100% !important;
        .jquery-datatable {
            width: 100% !important;
            tbody {
                tr {
                    height: 45px !important;
                    color: #6e6b7b;
                    background: var(--vs-hex-white);

                    &:hover {
                        background: #f5f5f5;
                    }

                    td {
                        border-bottom: 1px solid rgba($color: #B9B9C3, $alpha: 0.5);
                        padding: 8px 18px;

                    }
					&:first-child {
						line-break: anywhere;
					}
                }
            }

            .dataTables_empty--hidden {
                border-bottom: 1px solid transparent;
            }
        }
    }
	.dataTables_scrollFoot{
		overflow: hidden;
		position: relative;
		width: 100%;
		.dataTables_scrollFootInner {
			@media only screen and (min-width:1401px) {
				width: 100% !important;
			}
			.jquery-datatable {
				width: 100% !important;
			}
		}
	}
    

    .bottom {
        display: flex;
        flex-direction: column;

        // Hidden default info of data table
        .dataTables_info {
            display: none;
        }

        // Hidden this css custom because we maybe don't need it
        // .dataTables_length {
        //     position: absolute;
        //     bottom: 0;
        //     left: 0;
        // }

        // .dataTables_paginate {
        //     align-self: flex-end;
        //     .paginate_button {
        //         &.current {
        //             border-radius: 50%;
        //             background: var(--vs-hex-primary) !important;
        //             color: var(--vs-hex-white) !important;
        //             font-size: 15px;
        //             font-weight: 500;
        //             border: 1px solid transparent !important;
        //         }

        //         &:not(:last-child, :first-child, .current) {
        //             background: transparent !important;
        //         }

        //         &:hover:not(.current),
        //         &:focus {
        //             background: transparent !important;
        //             color: var(--vs-hex-dark) !important;
        //             border: 1px solid transparent !important;
        //             box-shadow: none;
        //         }

        //         &.current:hover {
        //             color: var(--vs-hex-white) !important;
        //             border: 1px solid transparent !important;
        //         }

        //         &.current:focus {
        //             background: var(--vs-hex-primary) !important;
        //         }
        //     }
        // }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Datatable/JDataTable.vue